import { useEffect, useRef, useState } from "react";

const useScrollOnMount = ({ watch, disabled = false, delay = null }) => {
  const [ref, setRef] = useState();
  const timeoutRef = useRef();

  useEffect(() => {
    if (ref) {
      timeoutRef.current = setTimeout(
        () => ref.scrollIntoView({ behavior: "smooth" }),
        delay || 19
      );
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [ref, watch]);

  return disabled ? null : setRef;
};

export default useScrollOnMount;
